<mat-dialog-content class="customer-dialog">

<!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Unit Code</mat-label>
      <input matInput [(ngModel)]="unCode" (keyup)="retriveUnitsLookup()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Unit Name</mat-label>
      <input matInput [(ngModel)]="unName" (keyup)="retriveUnitsLookup()">
    </mat-form-field>

  </div>

  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
          <th style="width: 30%;">Unit Code</th>
          <th style="width: 100%;">Unit Name</th>
          <th style="width: 30%;">Unit Each</th>
          <th style="width: 20%;">Choose</th>
        </tr>

      </thead>
      <tbody>
    <tr *ngFor="let Units of unitsList; let i = index">
          <td>{{Units.unCode}}</td>
          <td>{{Units.unName}}</td>
          <td>{{Units.unrach}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectUnit(Units)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
